/* eslint-disable no-nested-ternary */
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { useTheme } from 'styled-components';
import { IconContainer } from './styles';

interface SortIconsProps {
  isSorted: boolean;
  isSortedDesc?: boolean;
}

export const SortIcons = ({ isSorted, isSortedDesc }: SortIconsProps) => {
  const theme = useTheme();
  return (
    <IconContainer>
      <FaChevronUp
        color={
          !isSorted || isSortedDesc
            ? theme.colors.textLight
            : theme.colors.title
        }
        size={10}
      />
      <FaChevronDown
        color={
          !isSorted || !isSortedDesc
            ? theme.colors.textLight
            : theme.colors.title
        }
        size={10}
      />
    </IconContainer>
  );
};
